var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.4 2H1.6C0.72 2 0.00799999 2.72 0.00799999 3.6L0 13.2C0 14.08 0.72 14.8 1.6 14.8H14.4C15.28 14.8 16 14.08 16 13.2V3.6C16 2.72 15.28 2 14.4 2ZM14.4 5.2L8 9.2L1.6 5.2V3.6L8 7.6L14.4 3.6V5.2Z",
    fill: "white",
    fillOpacity: 0.87
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.630aeb7f8e9e3cb04cbcfadb785dc8f7.svg";
export { ForwardRef as ReactComponent };